import { useEffect } from "react";

const Login = () => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
      // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    },
    false
  );
  return (
    <div>
      <div className="bg-[#efefef] flex flex-col justify-center items-center h-[150px]">
        <h1 className="sm:text-[40px] text-[30px] font-bold">
          Customer Portals
        </h1>
      </div>

      <div className="flex justify-center items-center mt-12 mb-[100px]">
        <div className="flex gap-6 justify-center items-center flex-wrap max-w-[60rem]">
          <div className="flex flex-col justify-center items-center w-[18rem] ">
            <a
              href="https://envio.tcscourier.com/UserAccount/Login/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/login/envio.png" alt="" />
            </a>
          </div>
          <div className="flex flex-col justify-center items-center w-[18rem] ">
            <a
              href="https://ship4me.tcscourier.com/apex/f?p=104"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/login/shipforme.png" alt="" />
            </a>
          </div>
          <div className="flex flex-col justify-center items-center w-[18rem] ">
            <a
              href="https://cards.tcs.com.pk/tcscards"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/login/loyaltycard.png" alt="" />
            </a>
          </div>
          <div className="flex flex-col justify-center items-center w-[18rem] ">
            <a
              href="https://wd.tcslogistics.com/ords/f?p=3PLPRO_CUSTOMER"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/login/3pl.png" alt="" />
            </a>
          </div>
          <div className="flex flex-col justify-center items-center w-[18rem] ">
            <a
              href="http://webapp.tcscourier.com/COD/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/login/e-retailportal.png" alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
